<!-- eslint-disable prettier/prettier -->
<template>
  <div class="home">
    <div class="top-bar">
      <span class="welcome">{{ welcomeText }}</span>
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>

    <div class="content-area">
      <div class="header-section">
        <h1 class="main-title">餐厅系统</h1>
      </div>

      <div class="card-container">
        <div class="role-card">
          <div class="card-content">
            <h2 class="card-title">请选择功能</h2>

            <router-link
              v-for="entry in visibleEntries"
              :key="entry.name"
              :to="entry.path"
              class="menu-card"
            >
              <div class="menu-icon">{{ entry.icon }}</div>
              <div class="menu-title">{{ entry.title }}</div>
              <div class="menu-desc">点击进入</div>
            </router-link>

          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <p>© 2025 点餐系统 v1.0</p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '@/store/auth';
  import { useGlobalMenu } from '@/composables/useGlobalMenu';

  const authStore = useAuthStore();
  const router = useRouter();
  const { entries } = useGlobalMenu();

  const visibleEntries = computed(() => entries.value);

  const welcomeText = computed(() => {
    const displayName = authStore.user?.displayName || authStore.user?.username || '员工';
    return `${displayName}，欢迎使用`;
  });

  const handleLogout = async (): Promise<void> => {
    await authStore.logout();
    await router.replace('/login');
  };
</script>

<style scoped>
  .home {
    background-color: #f5f5f5;
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
  }

  .welcome {
    color: #475569;
    font-size: 14px;
  }

  .logout-btn {
    border: none;
    border-radius: 8px;
    padding: 8px 12px;
    background: #e2e8f0;
    color: #1e293b;
    cursor: pointer;
  }

  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }

  .header-section {
    text-align: center;
    margin-bottom: 1.2rem;
  }

  .main-title {
    font-size: 2.1rem;
    font-weight: bold;
    margin: 0;
  }

  .card-container {
    width: 100%;
    max-width: 920px;
  }

  .role-card {
    background-color: white;
    border-radius: 0.75rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 1.5rem;
  }

  .card-content {
    padding: 1.5rem;
  }

  .card-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .card-content {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .card-title,
  .empty-permission {
    grid-column: 1 / -1;
  }

  .menu-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-height: 136px;
    border-radius: 14px;
    padding: 16px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e2e8f0;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
    text-decoration: none;
    color: #0f172a;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .menu-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  }

  .menu-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    background: #eff6ff;
    margin-bottom: 10px;
  }

  .menu-title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 8px;
  }

  .menu-desc {
    color: #64748b;
    font-size: 13px;
  }

  .empty-permission {
    border-radius: 8px;
    background: #f8fafc;
    color: #64748b;
    padding: 12px;
    font-size: 14px;
  }

  .footer {
    padding: 1rem;
    text-align: center;
    color: #6b7280;
    font-size: 0.875rem;
  }

  @media (max-width: 768px) {
    .card-content {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .main-title {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 520px) {
    .card-content {
      grid-template-columns: 1fr;
    }
  }
</style>
